import { Input, ErrorMessage } from 'styles/Styles.styled';
import { useField } from 'formik';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';

const TextInput = ({ label, enableTooltipError, ...props }: any) => {
  const theme = useTheme() as Theme;

  const [field, meta] = useField(props);
  return (
    <>
      <SmartLabel
        htmlFor={props.id || props.name}
        label={label}
        labelStyle={{ fontFamily: `${theme.fontFamilies.body}`, fontSize: `${theme.fontSizes.small}rem` }}
        boxStyle={{ marginBottom: 0 }}
        required={props.required}
        hasValue={enableTooltipError ? !!field.value && field.value !== '' : true}
        error={enableTooltipError && meta.touched && meta.error ? meta.error : undefined}
      />
      <Input {...field} {...props} />
      {meta.touched && meta.error && !props.supressErrors ? <ErrorMessage>{meta.error}</ErrorMessage> : null}
    </>
  );
};

export default TextInput;
